export default __webpack_public_path__ + "static/media/Group11903.26b002c6.svg";